import { render, staticRenderFns } from "./reise-standard-data-edit-form.vue?vue&type=template&id=1349585e"
import script from "./reise-standard-data-edit-form.vue?vue&type=script&lang=js"
export * from "./reise-standard-data-edit-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports